import { RouteComponentProps } from "@reach/router";
import React from "react";
import { ReportDownload } from "../../../components/ReportDownload/ReportDownload";
import { SMB_REPORTS } from "../../../config/reports";

export const Reports: React.FunctionComponent<RouteComponentProps> = () => {
  return <ReportDownload reports={SMB_REPORTS} />;
};
